import React, { useState, useEffect } from 'react';
import {Col, Row, Switch, Card, Input, Form, Button, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import Wrapper from '../comnon/wrapper';
import useTitle from '../comnon/title';
import UploadFilesandLogo from '../comnon/uploadFilesandLogo';
import UserSupportGuide from './userSupportGuide';
import BreadcrumbLayout from '../layout/breadcrumb';
const Settings = () => {

    const { t, i18n } = useTranslation();
    useTitle(t("settings.view_title"));
    const dispatch = useDispatch();
    const { isSettingToggleLoading, settingToggleStatus, settingsData, isSettingLoading, isSettingUpdateStatus, isSettingUpdateLoading } = useSelector(state => state.user);

    const [isSwitchLoading, setIsSwitchLoading] = useState(false);
    const [checked, setChecked] = useState(false);
    const [logo, setLogo] = useState({});
    const [existsSettingData, setSettingsData] = useState({});
    const [form] = Form.useForm();

    useEffect(() => {
        loadSettings();
    }, []);

    const loadSettings = (params = {}) => {
        dispatch({ type: 'SETTINGS_REQUEST', formData: params });

    }

    const onSwitchChange = (e) => {
        dispatch({ type: "TOGGLE_SETTINGS_REQUEST", status: e })
    }

    useEffect(() => {
        if (!isSettingToggleLoading && Object.keys(settingToggleStatus).length > 0) {
            loadSettings();
        }
    }, [isSettingToggleLoading, settingToggleStatus]);

    useEffect(() => {
        if (!isSettingUpdateLoading && isSettingUpdateStatus === "success") {
            setLogo({});
            loadSettings();
        }
    }, [isSettingUpdateLoading, isSettingUpdateStatus]);

    useEffect(() => {
        if (!isSettingLoading && Object.keys(settingsData).length > 0) {
            setIsSwitchLoading(true);
            setChecked(settingsData.enable_stream_survey === 1 ? true : false);
            form.setFieldsValue({ default_email: settingsData.default_email !== null ? settingsData.default_email : "" })
            form.setFieldsValue({
                enable_stream_survey: settingsData.enable_stream_survey,
                embed_code_url: settingsData.embed_code_url,
                embed_code_url_fr: settingsData.embed_code_url_fr,
                filter_field_1: settingsData.filter_field_1,
                filter_field_2: settingsData.filter_field_2,
                client_name: settingsData.client_name
            });
            setSettingsData(settingsData);
            setTimeout(() => {
                setIsSwitchLoading(false);
            }, 200);
        }
    }, [settingsData, isSettingLoading]);

    const onFinish = (values) => {
        let formData = new FormData();

        for (const property in values) {
            formData.append(property, values[property])
        }

        if (Object.keys(logo).length > 0) {
            formData.append('logo', logo)
        }

        dispatch({ type: "UPDATE_SETTINGS_REQUEST", formData: formData })
    }
    const onFinishFailed = () => { }
    return (
        <Wrapper title="survey_id View" >
            <BreadcrumbLayout />
            <div className='p8 bg-white input-class'>
                {isSettingLoading && <Spin style={{ width: "100%" }} />}
                {!isSettingLoading &&
                    <>
                        <Form
                            layout='vertical'
                            className='sign-form'
                            name='basic'
                            form={form}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                        >
                            <Row className='nav-sub-header'>
                                <Col xs={24} sm={24} md={16} lg={16} xl={16} className="red">
                                    <Card className='archive-card'>
                                        <div className='content'>
                                            <p>{t('settings.label')}</p>
                                            <div className='switch-delete'>
                                                <p>
                                                    {isSwitchLoading && <Switch
                                                        checkedChildren={<span>{t('settings.enable')}</span>}
                                                        unCheckedChildren={<span>{t('settings.disabled')}</span>}
                                                        defaultChecked={checked}
                                                        size='large'
                                                        loading={isSwitchLoading}
                                                    />}
                                                    {!isSwitchLoading && <p>
                                                        <Switch
                                                            checkedChildren={<span>{t('settings.enable')}</span>}
                                                            unCheckedChildren={<span>{t('settings.disabled')}</span>}
                                                            defaultChecked={checked}
                                                            onChange={(e) => onSwitchChange(e)}
                                                            size='large'
                                                            loading={isSwitchLoading || isSettingToggleLoading}
                                                        />
                                                    </p>}
                                                </p>
                                            </div>
                                        </div>
                                    </Card>
                                </Col>

                            </Row>

                            <Row>
                                <Col xs={24} className="red">
                                    <Form.Item
                                        label={t('settings.embed_code_label')}
                                        name='embed_code_url'
                                        className='form-field'
                                        rules={[
                                            {
                                                required: false
                                            },
                                            {
                                                type: 'url',
                                                message: t('settings.enter_valid_url'),
                                            }
                                        ]}
                                    >
                                        <Input style={{ width: "600px" }} size="large" placeholder={t('settings.embed_code_label')} />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={24} className="red">
                                    <Form.Item
                                        label={t('settings.embed_code_label_fr')}
                                        name='embed_code_url_fr'
                                        className='form-field'
                                        rules={[
                                            {
                                                required: false
                                            },
                                            {
                                                type: 'url',
                                                message: t('settings.enter_valid_url'),
                                            }
                                        ]}

                                    >
                                        <Input style={{ width: "600px" }} size="large" placeholder={t('settings.embed_code_label')} />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={24} sm={24} md={16} lg={16} xl={16} className="red">
                                    <Form.Item
                                        style={{ display: 'none' }}
                                        name={'enable_stream_survey'}
                                        className='form-field'
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('settings.support_label')}
                                        name='default_email'
                                        className='form-field'
                                        rules={[
                                            {
                                                type: 'email',
                                                message: t('user.error_email_valid'),
                                            },
                                            {
                                                required: false,
                                                message: t('user.error_email'),
                                            }
                                        ]}
                                    >
                                        <Input style={{ width: "350px" }} size="large" placeholder={t('settings.support_label')} />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24} className="red">
                                    <Form.Item
                                        label={t('settings.client_name')}
                                        name='client_name'
                                        className='form-field'
                                        rules={[
                                            {
                                                required: false,
                                                message: '',
                                            }
                                        ]}
                                    >
                                        <Input style={{ width: "350px" }} size="large" placeholder={t('settings.client_name')} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={8} lg={8} xl={8} className="red">
                                    <Form.Item
                                        label={t('settings.filter_field1')}
                                        name='filter_field_1'
                                        className='form-field'
                                        rules={[
                                            {
                                                required: false,
                                                message: '',
                                            }
                                        ]}
                                    >
                                        <Input style={{ width: "350px" }} size="large" placeholder={t('settings.filter_field1')} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={8} lg={8} xl={8} className="red">
                                    <Form.Item
                                        label={t('settings.filter_field2')}
                                        name='filter_field_2'
                                        className='form-field'
                                        rules={[
                                            {
                                                required: false,
                                                message: '',
                                            }
                                        ]}
                                    >
                                        <Input style={{ width: "350px" }} size="large" placeholder={t('settings.filter_field2')} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            {!isSettingLoading &&
                                <Row>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className="red">
                                        <Form.Item
                                            label={t('settings.logo')}
                                            className='form-field'
                                        >
                                            <UploadFilesandLogo
                                                fileName={settingsData.logo_url}
                                                supportType="image"
                                                setFileObj={(e) => {
                                                    setLogo(e)
                                                }}
                                                label={t('settings.upload_logo')}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            }
                            <Row>
                                <Button
                                    htmlType="submit"
                                    type="primary"
                                    shape="round"
                                    loading={isSettingUpdateLoading}
                                    disabled={isSettingUpdateLoading}
                                    size={"large"}>
                                    {t('common.update')}
                                </Button>
                            </Row>
                        </Form>
                    </>
                }
                <UserSupportGuide />
            </div>
        </Wrapper>
    )
};

export default Settings;                    
